import { Lock } from "lucide-react";
import { useNavigate } from "@tanstack/react-router";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface UpgradeCardProps {
  feature: string;
  description: string;
}

export function UpgradeCard({ feature, description }: UpgradeCardProps) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center h-full min-h-[300px]">
      <Card className="max-w-md">
        <CardContent className="pt-6 text-center space-y-4">
          <div className="mx-auto w-12 h-12 rounded-full bg-muted flex items-center justify-center">
            <Lock className="size-6 text-muted-foreground" />
          </div>
          <div>
            <h3 className="text-lg font-semibold">{feature}</h3>
            <p className="text-sm text-muted-foreground mt-1">{description}</p>
          </div>
          <p className="text-sm text-muted-foreground">Available on Pro</p>
          <Button onClick={() => navigate({ to: "/settings/billing" })}>
            Upgrade to Pro
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
